import { render, staticRenderFns } from "./Table-list.vue?vue&type=template&id=28a0c5b8"
import script from "./Table-list.vue?vue&type=script&lang=js"
export * from "./Table-list.vue?vue&type=script&lang=js"
import style0 from "./Table-list.vue?vue&type=style&index=0&id=28a0c5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports